import React from 'react'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import { selectHasAnyTaskManagementBp } from 'features/auth/ducks/selectors'
import ComplianceInactiveNotice from 'features/dashboard/sections/ComplianceInactiveNotice'

const TaskManagementGuard = ({ children }) => {
  const hasAnyTaskManagementBp = useSelector(selectHasAnyTaskManagementBp)
  if (!hasAnyTaskManagementBp) {
    return (
      <Wrap>
        <ComplianceInactiveNotice />
      </Wrap>
    )
  }
  return children
}

export default TaskManagementGuard

const Wrap = styled.div`
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  padding: 24px;
  box-sizing: border-box;
`
